import { defineMessages } from 'react-intl'

export default defineMessages({
  email: {
    id: 'OrganizationUsersPage.UserName.PlaceHolder',
    defaultMessage: 'first.last@company.com'
  },
  field_externalId: {
    id: 'OrganizationUsersPage.ExternalId.PlaceHolder',
    defaultMessage: 'Id from provisioning client'
  },
  'field_name.givenName': {
    id: 'OrganizationUsersPage.FirstName.Placeholder',
    defaultMessage: 'First Name'
  },
  'field_name.familyName': {
    id: 'OrganizationUsersPage.LastName.PlaceHolder',
    defaultMessage: 'Last Name'
  },
  'field_name.formatted': {
    id: 'OrganizationUsersPage.FormattedField.PlaceHolder',
    defaultMessage: 'Formatted name'
  },
  'field_name.honorificPrefix': {
    id: 'OrganizationUsersPage.HonorificPrefixField.PlaceHolder',
    defaultMessage: "Honorific prefix(es) (e.g., 'Ms.')"
  },
  'field_name.honorificSuffix': {
    id: 'OrganizationUsersPage.HonorificSuffixField.PlaceHolder',
    defaultMessage: "Honorific suffix(es) (e.g., 'III')"
  },
  'field_name.middleName': {
    id: 'OrganizationUsersPage.MiddleNameField.PlaceHolder',
    defaultMessage: 'Middle Name'
  },
  field_nickName: {
    id: 'OrganizationUsersPage.NickName.PlaceHolder',
    defaultMessage: 'Nick Name'
  },
  field_userType: {
    id: 'OrganizationUsersPage.UserType.PlaceHolder',
    defaultMessage: "'Contractor', 'Employee', etc..."
  },
  field_displayName: {
    id: 'OrganizationUsersPage.DisplayName.PlaceHolder',
    defaultMessage: 'nickname or preferred name'
  },
  field_title: {
    id: 'OrganizationUsersPage.TitleField.PlaceHolder',
    defaultMessage: "User's formal title within organization"
  },
  field_timezone: {
    id: 'OrganizationUsersPage.TimeZone.Placeholder',
    defaultMessage: 'America/New York'
  },
  field_preferredLanguage: {
    id: 'OrganizationUsersPage.LanguagePreference.Placeholder',
    defaultMessage: 'en-us'
  },
  field_profileUrl: {
    id: 'OrganizationUsersPage.ProfileURL.PlaceHolder',
    defaultMessage: 'https://www.exampleurl.com/employee-1'
  },
  'field_enterpriseUser.employeeNumber': {
    id: 'OrganizationUsersPage.EmployeeNum.PlaceHolder',
    defaultMessage: '1234'
  },
  'field_enterpriseUser.costCenter': {
    id: 'OrganizationUsersPage.CostCenter.PlaceHolder',
    defaultMessage: '#1234'
  },
  'field_enterpriseUser.organization': {
    id: 'OrganizationUsersPage.Organization.PlaceHolder',
    defaultMessage: "User's Organization"
  },
  'field_enterpriseUser.department': {
    id: 'OrganizationUsersPage.Department.PlaceHolder',
    defaultMessage: "User's Department"
  },
  'field_enterpriseUser.division': {
    id: 'OrganizationUsersPage.Division.PlaceHolder',
    defaultMessage: 'East Region'
  },
  'field_enterpriseUser.manager.value': {
    id: 'OrganizationUsersPage.Value',
    defaultMessage: 'Value'
  },
  'field_enterpriseUser.manager.displayName': {
    id: 'OrganizationUsersPage.DisplayName.PlaceHolder',
    defaultMessage: 'nickname or preferred name'
  },
  field_isOrgAdmin: {
    id: 'OrganizationUsersPage.OrgAdmin',
    defaultMessage: 'Organization Admin'
  },
  'field_addresses[0].locality': {
    id: 'OrganizationUsersPage.Locality',
    defaultMessage: 'City'
  },
  'field_addresses[0].postalCode': {
    id: 'OrganizationUsersPage.PostalCode',
    defaultMessage: 'Postal Code'
  },
  'field_addresses[0].region': {
    id: 'OrganizationUsersPage.Region',
    defaultMessage: 'State/Region'
  },
  'field_addresses[0].country': {
    id: 'OrganizationUsersPage.Country',
    defaultMessage: 'Country'
  },
  'field_addresses[0].streetAddress': {
    id: 'OrganizationUsersPage.StreetAddress',
    defaultMessage: 'Street Address'
  },
  'field_addresses[0].formatted': {
    id: 'OrganizationUsersPage.Formatted',
    defaultMessage: 'Formatted Address'
  },
  'field_addresses[0].type': {
    id: 'OrganizationUsersPage.AddressType',
    defaultMessage: 'Type'
  },
  'field_addresses[0].primary': {
    id: 'OrganizationUsersPage.Primary',
    defaultMessage: 'Primary'
  },
  'field_emails[0].value': {
    id: 'OrganizationUsersPage.Value',
    defaultMessage: 'Value'
  },
  'field_emails[0].type': {
    id: 'OrganizationUsersPage.Type.PlaceHolder',
    defaultMessage: 'home, work, other, etc...'
  },
  'field_emails[0].display': {
    id: 'OrganizationUsersPage.Display',
    defaultMessage: 'Display'
  },
  'field_emails[0].primary': {
    id: 'OrganizationUsersPage.Primary',
    defaultMessage: 'Primary'
  },
  'field_phoneNumbers[0].value': {
    id: 'OrganizationUsersPage.Value',
    defaultMessage: 'Value'
  },
  'field_phoneNumbers[0].type': {
    id: 'OrganizationUsersPage.Type.PlaceHolder',
    defaultMessage: 'home, work, other, etc...'
  },
  'field_phoneNumbers[0].display': {
    id: 'OrganizationUsersPage.Display',
    defaultMessage: 'Display'
  },
  'field_phoneNumbers[0].primary': {
    id: 'OrganizationUsersPage.Primary',
    defaultMessage: 'Primary'
  },
  'field_photos[0].value': {
    id: 'OrganizationUsersPage.Value',
    defaultMessage: 'Value'
  },
  'field_photos[0].type': {
    id: 'OrganizationUsersPage.Type.PlaceHolder',
    defaultMessage: 'home, work, other, etc...'
  },
  'field_photos[0].display': {
    id: 'OrganizationUsersPage.Display',
    defaultMessage: 'Display'
  },
  'field_photos[0].primary': {
    id: 'OrganizationUsersPage.Primary',
    defaultMessage: 'Primary'
  },
  description: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.Description',
    defaultMessage: 'Drag and drop a CSV containing at minimum: email, first name, and last name.'
  },
  bulkExample: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.Example',
    defaultMessage: 'Examples:'
  },
  downloadSimple: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.DownloadSimple',
    defaultMessage: 'simple csv file'
  },
  downloadAll: {
    id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.DownloadFull',
    defaultMessage: 'all fields csv file'
  },
  or: { id: 'OrganizationUsersBulkAddPage.Bulk.Tooltip.Or', defaultMessage: 'or' }
})
